import { render } from "./Orginazation.vue?vue&type=template&id=5df543ec&scoped=true"
import script from "./Orginazation.vue?vue&type=script&lang=js"
export * from "./Orginazation.vue?vue&type=script&lang=js"

import "./Orginazation.vue?vue&type=style&index=0&id=5df543ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ken\\Documents\\GitHub\\KasongNursingHome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df543ec"]])

export default __exports__